import { apiClient } from '../client';

export interface Guide {
  id: string;
  locationId: string;
  slug: string;
  title: string;
  guideType: string;
  content: string;
  metaDescription: string;
  isPublished: boolean;
  locationName: string;
  locationState: string;
  locationSlug: string;
  createdAt: string;
  updatedAt: string;
}

export interface GuideSummary {
  slug: string;
  title: string;
  guideType: string;
  metaDescription: string;
}

interface GuideResponse {
  success: boolean;
  guide: Guide;
}

interface GuidesByLocationResponse {
  success: boolean;
  guides: GuideSummary[];
}

interface GuidesListResponse {
  success: boolean;
  guides: Guide[];
  total: number;
}

export const guidesApi = {
  /** Get all published guides */
  getAll: async (): Promise<GuidesListResponse> => {
    const { data } = await apiClient.get<GuidesListResponse>('/v1/guides');
    return data;
  },

  /** Get a guide by slug (public) */
  getBySlug: async (slug: string): Promise<GuideResponse> => {
    const { data } = await apiClient.get<GuideResponse>(`/v1/guides/${slug}`);
    return data;
  },

  /** Get all guides for a location (public) */
  getByLocation: async (locationSlug: string): Promise<GuidesByLocationResponse> => {
    const { data } = await apiClient.get<GuidesByLocationResponse>(`/v1/guides/by-location/${locationSlug}`);
    return data;
  },
};
